import {useState,useRef,useEffect} from 'react';
import Head from 'next/head';
import dynamic from 'next/dynamic';
import Header_PC from './../component/pc/header/header';
import Login_PC from './../component/pc/login/login';
import { resetIdCounter } from 'react-tabs';
// import Footer_PC from './../component/pc/login/footer';
import styles from './../css/pc/login/login.module.scss';
import {pubPath,regMobile} from '@/config/config';

const Flexible = dynamic(
    import ('./../js/flexible').then((mod)=>mod.flexible),{ssr:false}
)

const Footer_PC = dynamic(
    import('./../component/pc/login/footer').then((mod) => mod), { ssr: false }
)

const Login = ({flag,data}) => {
    const [personalInfo, setPersonalInfo] = useState({});
    const [refreshTag, setRefreshTag] = useState('');
    
    
    
    return (
    	<div className={styles.wholeBg}>
            <Head>
                <title>FX168财经-注册登录</title>
                <link rel="shortcut icon" href="/img/favicon.ico" type="image/x-icon" />
                <script src="noSupport.js"></script>
                <script src="https://turing.captcha.qcloud.com/TCaptcha.js"></script>
            </Head>
            <Flexible />
            {/*<Header_PC params={{setPersonalInfo:setPersonalInfo,personalInfo:personalInfo,refreshTag:refreshTag,setRefreshTag:setRefreshTag}} />*/}
            <Login_PC flag={flag} />
            <Footer_PC />
        </div>
    );
};


export async function getServerSideProps(context){
    const userAgent = context.req ? context.req.headers['user-agent'] : navigator.userAgent;
    const flag=userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i);
    resetIdCounter();
    return {
        props:{
            flag
        },
    }
}




export default Login;
